// removed by extract-text-webpack-plugin
module.exports = {"gridSection":"_2PsHkgXOiEKuI-NFEUmEBD","gridList":"TnXmxMqrstHTU95PVHhu"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/foundations/Grids/Grids.css
// module id = 815
// module chunks = 0